export default __webpack_public_path__ + "static/media/Quiken_Logo_Bco-44.6014abf1.svg";